const Cross = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2 14L14 2M14 14L2 2"
                stroke="#696158"
                strokeWidth="2.5"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default Cross
